<template>
  <div class="searchpanel">
    <div class="filters d-flex align-items-center">
      <OposDatepicker
        class="datepicker"
        :range="search.range_date"
        :selected="this.selectedRange"
        @input="range"
      />

      <b-dropdown
        text="Firma"
        ref="comapny"
        class="dropdowns mb-3 mr-3"
        @hide="updateCompany"
      >
        <b-dropdown-form class="b-dropdown-form--minpadding">
          <b-form-checkbox-group
            name="comapny"
            v-model="company"
            :options="companiesList"
            class="checkbox-group-stacked"
             stacked
          ></b-form-checkbox-group>
        </b-dropdown-form>
      </b-dropdown>

      <b-dropdown
        text="Status"
        ref="status"
        class="dropdowns mb-3 mr-3"
        @hide="updateStatus"
      >
        <b-dropdown-form class="b-dropdown-form--minpadding">
          <b-form-checkbox-group
            name="status"
            v-model="status"
            :options="avaibleStatus"
            class="checkbox-group-stacked"
            stacked
          ></b-form-checkbox-group>
        </b-dropdown-form>
      </b-dropdown>

      <b-form-group
        label-class="mr-3"
        class="searchpanel-item mb-3"
        label-for="categories"
      >
        <multiselect
          id="categories"
          class=""
          v-model="selectedOwners"
          placeholder="Filtruj po kierowniku"
          label="name"
          track-by="id"
          :options="options"
          :multiple="true"
          :max="8"
          style="min-width: 300px"
          @input="updateOwners"
        ></multiselect>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import OposDatepicker from "@/components/opos/OposDatepicker";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "OposSearchPanel",
  components: { OposDatepicker },
  props: {
    companies: Array,
  },
  data() {
    return {
      options: [],
      company: [],
      status: [],
      selectedOwners: [],
    };
  },
  computed: {
    ...mapGetters("opos", ["selectedRange", "search"]),
    ...mapGetters("app", ["optionsStatus", "availableEmployees"]),
    ...mapGetters("user", ["isNotSubcontractor"]),
    avaibleStatus() {
      let avaibleStatus = [],
        isSubcontractor = !this.isNotSubcontractor;
      this.$_.each(this.optionsStatus, (item) => {
        if (item.value === "not_payment" && isSubcontractor) {
          return;
        }
        avaibleStatus.push(item);
      });
      return avaibleStatus;
    },
    companiesList() {
      let avaibleCompanies = [];
      this.companies.forEach(item => {
        item.value = item.id;
        item.text = item.name;
        avaibleCompanies.push(item);
      });
    return avaibleCompanies;
    }
  },
  mounted() {
    this.status = this.search.status;
    this.selectedOwners = this.search.owners;
    // this.owner = this.search.owner;
    // this.q = this.search.q;
  },
  created() {
    let loadQueue = [this.loadAvailableEmployees()];
    Promise.all(loadQueue).then(() => {
      this.options = this.availableEmployees("onlyEmployee");
      for (var i = 0; i < this.options.length; i++) {
        this.options[i].id = i + 1;
        this.options[i].name = this.options[i].text;
      }
    });
  },
  methods: {
    ...mapActions("app", ["loadAvailableEmployees"]),
    range(range, selected) {
      if (range) {
        this.$store.commit("opos/range", {
          selected: selected,
          range: range,
        });
        this.$emit("filtersChanged");
      }
    },
    updateCompany() {
      this.$store.commit("opos/company", this.company);
      this.$emit("filtersChanged");
    },
    updateStatus() {
      this.$store.commit("opos/status", this.status);
      this.$emit("filtersChanged");
    },
    updateOwners(value) {
      var owners = [];
      value.forEach((v) => {
        owners.push(v);
      });
      this.$store.commit("opos/owners", owners);
      this.$emit("filtersChanged");
    },
  },
};
</script>
